// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"dcraw":[function(require,module,exports) {
// messageGenerator.js
// Static success messages without dynamic content
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Function to return a formatted random message based on streak length
parcelHelpers.export(exports, "getSuccessMessage", ()=>getSuccessMessage);
parcelHelpers.export(exports, "getStreakSymbols", ()=>getStreakSymbols);
parcelHelpers.export(exports, "generateSocialMediaPost", ()=>generateSocialMediaPost);
const successMessages = {
    short: [
        `Great start! \u{1F389} You've completed your workout and have a {streak} day streak! Keep going!`,
        `Nice job! \u{1F31F} You've nailed a {streak} day streak! You're off to a strong start!`,
        `Well done! \u{1F44F} You've completed your workout and are on a {streak} day streak! Awesome work!`
    ],
    medium: [
        `Fantastic! \u{1F973} You've finished your workout and reached a {streak} day streak! Keep pushing!`,
        `Awesome! \u{1F680} You've completed your workout and now have a {streak} day streak! You're making great progress!`,
        `Great work! \u{1F4AA} You've powered through your workout and hit a {streak} day streak! You're on the right track!`
    ],
    long: [
        `Incredible! \u{1F31F} You've crushed your workout and reached a {streak} day streak! You're unstoppable!`,
        `Superb! \u{1F388} You've completed your workout and are rocking a {streak} day streak! You're a superstar!`,
        `Amazing! \u{1F3AF} You've finished your workout and scored a {streak} day streak! You're doing fantastic!`
    ]
};
function getSuccessMessage(streak) {
    const messageList = streak <= 3 ? successMessages.short : streak <= 7 ? successMessages.medium : successMessages.long;
    const randomMessage = messageList[Math.floor(Math.random() * messageList.length)];
    return randomMessage.replace("{streak}", streak);
}
function getStreakSymbols(streak) {
    const symbols = {
        365: "\uD83D\uDE80",
        100: "\uD83D\uDCAF",
        50: "\uD83C\uDFC6",
        10: "\uD83C\uDFC5",
        1: "\uD83D\uDCAA" // 1 day
    };
    let streakString = "";
    // Sort the entries by milestone in descending order
    const sortedSymbols = Object.entries(symbols).sort((a, b)=>b[0] - a[0]);
    for (const [milestone, symbol] of sortedSymbols){
        const milestoneValue = Number(milestone);
        const count = Math.floor(streak / milestoneValue);
        if (count > 0) {
            streakString += symbol.repeat(count) + " ";
            streak %= milestoneValue;
        }
    }
    return streakString.trim();
}
const posts = {
    oneDay: [
        "Today's challenge? Crushed it. #HIITGenius",
        "One day down, feeling great. #HIITGenius",
        "Pushed through, no turning back. #HIITGenius"
    ],
    twoToFiveDays: [
        "Getting stronger every day. #HIITGenius",
        "Another step forward. #HIITGenius",
        "Feeling unstoppable. #HIITGenius",
        "On the right track. #HIITGenius",
        "Momentum is building! #HIITGenius"
    ],
    sixToTenDays: [
        "Kept the streak alive! #HIITGenius",
        "Not stopping now. #HIITGenius",
        "Kept the momentum going! #HIITGenius",
        "Making it look easy. #HIITGenius",
        "Streak status: active. #HIITGenius",
        "Consistency is key! #HIITGenius"
    ],
    tenPlusDays: [
        "Another one in the books! #HIITGenius",
        "Feeling unstoppable. #HIITGenius",
        "No stopping me now! #HIITGenius",
        "This streak is fire! #HIITGenius",
        "Still going strong! #HIITGenius",
        "Challenge? What challenge? #HIITGenius",
        "Powered through like a champ. #HIITGenius",
        "Consistency is my game. #HIITGenius",
        "Making every day count. #HIITGenius",
        "Another day, another victory. #HIITGenius",
        "I'm on a roll! #HIITGenius",
        "More progress, more strength. #HIITGenius",
        "Day after day, still crushing it. #HIITGenius",
        "This streak is going places! #HIITGenius",
        "One step closer to my goal. #HIITGenius"
    ]
};
function generateSocialMediaPost(streak) {
    let selectedPost;
    if (streak === 1) selectedPost = posts.oneDay[Math.floor(Math.random() * posts.oneDay.length)];
    else if (streak <= 5) selectedPost = posts.twoToFiveDays[Math.floor(Math.random() * posts.twoToFiveDays.length)];
    else if (streak <= 10) selectedPost = posts.sixToTenDays[Math.floor(Math.random() * posts.sixToTenDays.length)];
    else selectedPost = posts.tenPlusDays[Math.floor(Math.random() * posts.tenPlusDays.length)];
    const streakSymbols = getStreakSymbols(streak);
    const socialMediaPost = `${streakSymbols}\n${selectedPost}`;
    return socialMediaPost;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}]},["dcraw"], "dcraw", "parcelRequire3809")

//# sourceMappingURL=index.be9db580.js.map
